import { writable } from 'svelte/store'

export const user = writable({
    username: '',
    token: null,
    newPassword: '',
    verifyCode: '',
})

export const isLogged = writable(false)
export const gotCode = writable(false)
